import React from 'react';
import PropTypes from 'prop-types';
import InputFile from '../inputFile';

const ImportFile = ({
  children,
  afterUploadingFile,
  extensions,
}) => (
  <React.Fragment>
    <div style={{display: 'inline-block'}}>
    <InputFile id="importFile" showUpload={false} showDelete={false} afterUploadingFile={afterUploadingFile} extensions={extensions}>
      {!!children && (
        <div>
          {children}
        </div>
      )}
    </InputFile> </div>
  </React.Fragment>
);

ImportFile.propTypes = {
  afterUploadingFile: PropTypes.func.isRequired,
};

export default ImportFile;



// WEBPACK FOOTER //
// ./src/components/cms/form/importFile/ImportFile.jsx